function loadView(view) {
  return () => import(/* webpackChunkName: "view-[request]" */ `@/components/${view}.vue`)
}

// Dvisiones
export default [
  {
    path: 'tournaments/:tournamentId/divisions/:divisionId',
    name: 'DivisionBack',
    component: loadView('Back/Division/Division')
  },
  {
    path: 'tournaments/:tournamentId/divisions/:divisionId/seasons',
    name: 'DivisionBackSeasons',
    component: loadView('Back/Division/Seasons')
  },
  {
    path: 'tournaments/:tournamentId/divisions/:divisionId/teams',
    name: 'DivisionBackTeams',
    component: loadView('Back/Division/Teams')
  },
  {
    path: 'tournaments/:tournamentId/divisions/:divisionId/players',
    name: 'DivisionBackPlayers',
    component: loadView('Back/Division/Players')
  },
  {
    path: 'tournaments/:tournamentId/divisions/:divisionId/deliver-cup',
    name: 'DivisionBackDeliverCup',
    component: loadView('Back/Division/DeliverCup')
  },
  {
    path: 'tournaments/:tournamentId/divisions/:divisionId/custom-buttons',
    name: 'DivisionBackCustomButtons',
    component: loadView('Back/Division/CustomButtons')
  },
  {
    path: 'tournaments/:tournamentId/divisions/:divisionId/team-week',
    name: 'DivisionBackTeamWeek',
    component: loadView('Back/Division/TeamWeek')
  },
  {
    path: 'tournaments/:tournamentId/divisions/:divisionId/notices',
    name: 'DivisionBackNotices',
    component: loadView('Back/Division/Notices/List')
  },
  {
    path: 'tournaments/:tournamentId/divisions/:divisionId/notices/create',
    name: 'DivisionBackNoticesCreate',
    component: loadView('Back/Division/Notices/Create')
  },
  {
    path: 'tournaments/:tournamentId/divisions/:divisionId/notices/:noticeId/edit',
    name: 'DivisionBackNoticesEdit',
    component: loadView('Back/Division/Notices/Edit')
  },
  {
    path: 'tournaments/:tournamentId/divisions/:divisionId/liguillas',
    name: 'DivisionBackLiguilla',
    component: loadView('Back/Division/Liguilla')
  }
]
